export const uk = {
    'empty-priority': 'Не указан',
    title: 'Редактирование приоритета автобюджета'
};
